<template>
    <div id="home-m"  v-if="this.$store.state.isMobile">
        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                @scroll="contentScroll"
                :pull-up-load="true"
                @pullingUp="loadMore">
            <carousel-m></carousel-m>
            <card-m></card-m>
            <div id="ICP">
                <el-link href="http://beian.miit.gov.cn/" type="info">粤ICP备2021040975号</el-link>
            </div>
        </Scroll>
    </div>
</template>

<script>
    import Scroll from "../components/scroll/Scroll";
    import CarouselM from "../components/carousel/CarouselM";
    import CardM from "../components/card/CardM";
    import {debounce} from "../components/common/utils";
    import Loginform from "../components/loginform/Loginform";

    export default {
        name: "HomeM",
        data(){
            return{
                newRefresh:null,
            }
        },
        components:{
            Scroll,
            CarouselM,
            CardM,
            Loginform,
        },
        mounted() {
            // this.$refs.scroll.refresh;
            // this.newRefresh= debounce(this.$refs.scroll.refresh,100);
            // this.$on('imgLoad',this.newRefresh())
        },
        methods:{
            contentScroll(position){
                // this.isShowBackTop= (-position.y) >1000;
                // // this.showTabControl()
                // this.isTabFixed=position.y<(-this.tabOffsetTop);
            },
            loadMore(){
                // console.log('上拉加载更多')
                // this.getHomeGoods(this.currentType)
            },
        }
    }
</script>

<style scoped>
    #home-m{
        position: relative;
        height: 100vh;
        /*top: 40px;*/
    }
    .wrapper{
        position: relative;
        height: calc(100% - 93px);
        /*height: 580px;*/
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
    }
</style>